// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__Dc+-T","blur":"Overlay_blur__yjXuq","colored":"Overlay_colored__2Sj4v","appear":"Overlay_appear__kRxye"};